<div class="header-container">
  <img src="./../../../assets/images/illustrations/wendys-logo.png" />
</div>
